"use client";

import { useAccountState } from "#/store/wallet/account/accountState";
import { type Market } from "#/types/markets";

export const usePortfolioValidations = (market?: Market) => {
  const {
    portfolioState: { isLiquidated },
    hasZeroEquity,
    hasEquitySomewhere,
    hasTransferableEquity,
  } = useAccountState(market?.underlying);

  return {
    isLiquidated,
    hasZeroEquity,
    hasEquitySomewhere,
    hasTransferableEquity,
  };
};
